import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DisplayFilter } from '../loop-v2-filters.service';

@Component({
  selector: 'sales-common-loop-filter-chip',
  templateUrl: './loop-filter-chip.component.html',
  styleUrls: ['./loop-filter-chip.component.scss'],
})
export class LoopFilterChipComponent {
  @Input() filterItem: DisplayFilter;
  @Input() hideDelete: boolean;

  @Output() remove: EventEmitter<string> = new EventEmitter();
  @Output() clicked: EventEmitter<string> = new EventEmitter();

  clickedTag(): void {
    this.clicked.emit(this.filterItem.filterId);
  }

  removeTag(event: any): void {
    event.stopPropagation();
    this.remove.emit(this.filterItem.filterId);
  }
}
